/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Step_SortingInputs */

const vi_order_lot_trace_step_sorting = /** @type {(inputs: Order_Lot_Trace_Step_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô phân loại`)
};

/**

* @param {Order_Lot_Trace_Step_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_step_sorting = /** @type {((inputs?: Order_Lot_Trace_Step_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Step_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_step_sorting(inputs)
});